import { render, staticRenderFns } from "./ModalPresencaParticipantes.vue?vue&type=template&id=4e3dae8c"
import script from "./ModalPresencaParticipantes.vue?vue&type=script&lang=js"
export * from "./ModalPresencaParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports